{
  "winston": [
    {
      "durationMs": 1800,
      "gestures": [{ "atMs": 240, "durationMs": 1120, "pose": "head_tilt" }],
      "expressions": [
        { "atMs": 0, "durationMs": 320, "expression": "neutral" },
        { "atMs": 320, "durationMs": 1040, "expression": "hopeful" },
        { "atMs": 1360, "durationMs": 440, "expression": "neutral" }
      ],
      "blinkStartsMs": [960]
    },
    {
      "durationMs": 1600,
      "gestures": [{ "atMs": 300, "durationMs": 720, "pose": "emphasize" }],
      "expressions": [{ "atMs": 0, "durationMs": 1600, "expression": "neutral" }],
      "blinkStartsMs": [1080]
    }
  ],
  "asher": [
    {
      "durationMs": 1900,
      "gestures": [{ "atMs": 300, "durationMs": 1120, "pose": "side_eye" }],
      "expressions": [
        { "atMs": 0, "durationMs": 300, "expression": "neutral" },
        { "atMs": 300, "durationMs": 1120, "expression": "skeptical" },
        { "atMs": 1420, "durationMs": 480, "expression": "neutral" }
      ],
      "blinkStartsMs": [1020]
    },
    {
      "durationMs": 1600,
      "gestures": [{ "atMs": 240, "durationMs": 880, "pose": "side_eye" }],
      "expressions": [{ "atMs": 0, "durationMs": 1600, "expression": "neutral" }],
      "blinkStartsMs": [460]
    }
  ]
}
